export const APPLICATION_STATUS_COLOR_MAP: Record<string, string> = {
  pairing: 'bg-yellow-100 text-yellow-800 ring-yellow-200',
  completed: 'bg-green-100 text-green-800 ring-green-200',
  processing: 'bg-blue-100 text-blue-800 ring-blue-200',
  rejected: 'bg-red-100 text-red-800 ring-red-200',
};

export const DEFAULT_STATUS_COLOR = 'bg-gray-100 text-gray-700 ring-gray-200';

